import { Box, styled } from '@mui/material'

export const ScheduleSectionContainer = styled(Box)`
  max-height: 500px;
  overflow: auto;
`
